import { useEffect } from "react";
import Eduzy from "@/components/sections/Eduzy";

const JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://contentiumtech.com/#organization",
      name: "Contentium Tech",
      url: "https://contentiumtech.com",
      logo: "https://contentiumtech.com/logos/contentium-tech-logo.png",
      email: "info@contentiumtech.com",
      telephone: "+91-9654006470",
      address: { "@type": "PostalAddress", addressCountry: "IN" },
      subOrganization: {
        "@id": "https://eduzy.co/#organization",
      },
    },
    {
      "@type": "Organization",
      "@id": "https://eduzy.co/#organization",
      name: "Eduzy",
      alternateName: "Eduzy by Contentium Tech",
      url: "https://eduzy.co",
      logo: "https://contentiumtech.com/brand/eduzy-logo.png",
      email: "info@contentiumtech.com",
      telephone: "+91-9654006470",
      parentOrganization: {
        "@id": "https://contentiumtech.com/#organization",
      },
      description:
        "Eduzy is a learning initiative by Contentium Tech, focused on making quality education affordable, structured, and effective for students across India.",
    },
  ],
};

export default function EduzyPage() {
  useEffect(() => {
    document.title = "Eduzy — a product of Contentium Tech";
  }, []);

  return (
    <div data-testid="eduzy-page">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(JSONLD) }}
      />
      <Eduzy />
    </div>
  );
}
